import clsx from "clsx";
import React, { useRef, useState, useEffect, useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  AUTH_TOKEN,
  CALL,
  CALL_BREAK_REMARK,
  CALLBREAKID,
  CIRCLEONE_TEAM,
  CIRCLEONE_USER,
  CIRCLEONE_USERNAME,
  EXTENSION,
  QUEUE,
  TELEPHONEURL,
  TELEPHONY_LOGIN,
  TELEPHONYLOGINID,
  TELPEHONYLOGINUSERID,
  USER_LOGIN_PASSWORD,
  USER_TEAM_ID,
} from "../../../constants";
import { Dropdown } from "../../../helpers/components/Dropdown";
import { useLayout } from "../../../layout/core";
import { createInitials } from "../../../utils/functions/createInitials";
import { KTSVG } from "../../../helpers/components/KTSVG";
import { maskEmail } from "../../../utils/functions/maskData";
import ReactModal from "react-modal";
import axios from "axios";
import { toast } from "react-toastify";
import { useTelephony } from "../../../components/context/TelephonyContext";
import LoadingSkeleton from "../../../components/LoadingSkeleton";
import ContactModal from "../../../components/contact/contact/ContactModal";
import AccountModal from "../../../components/contact/accounts/AccountModal";
import TicketModal from "../../../components/ticket/TicketModal";
import { Button, Modal, Box, IconButton, Typography } from "@mui/material";
import { useLogoutMutation } from "../../../Services/Auth/Auth";
import LiveClock from "../../../components/auth/components/LiveClock";
import NotificationBell from "./NotificationBell";
import { useWebSocket } from "../../../context/WebSocketContext";
import ChatContext from "../../../context/ChatContext";
import UserContext from "../../../context/UserContext";
import { useCrmBgAccountCheckQuery } from "../../../Services/chat/Chat";
import { GridCloseIcon } from "@mui/x-data-grid";
import { useUpgradeModal } from "../../../context/UpgradeModalContext";

const TopRightTools: React.FC = () => {
  const { config } = useLayout();
  const location = useLocation(); // Get the current location
  const [isUserMenuOpen, setIsUserMenuOpen] = useState<boolean>(false);
  const [isUserMenuOpen2, setIsUserMenuOpen2] = useState<boolean>(false);
  const [permissionList, setPermissionList] = useState<any>([]);

  const headerUserDropdownMenuRef = useRef<HTMLDivElement>(null);

  const [storingUserName, setStoringUserName] = useState("");
  const [closeTopRightTool, setCloseTopRightTool] = useState(false);
  const [triggerLogout] = useLogoutMutation();
  const [queueus, setQueueus] = useState([]);
  const { setStoredTelephonyLoginDetails } = useTelephony();
  const { updateUserActiveStatus } = useContext(ChatContext);
  const { currentUser } = useContext(UserContext);
  const {
    setServerConfig,
    setExtensionNo,
    setUserName,
    setQueueNames,
    setCallBreakId,
    setIsLoading,
  } = useTelephony();

  const [loading, setLoading] = useState<boolean>(false);

  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    const storedLogin = localStorage.getItem(TELEPHONY_LOGIN);
    return storedLogin === "true";
  }); // State to track login status

  const [displayTenantName] = useState(
    () => localStorage.getItem(CIRCLEONE_USER) || ""
  );
  const [displayUserEmail] = useState(
    () => localStorage.getItem(CIRCLEONE_USERNAME) || ""
  );
  const [displayPassword] = useState(
    () => localStorage.getItem(USER_LOGIN_PASSWORD) || ""
  );
  const [displayTeamId] = useState(
    () => localStorage.getItem(USER_TEAM_ID) || ""
  );
  const [isSigningOut, setIsSigningOut] = useState(false);

  const permissionToShow = localStorage.getItem("user-token");
  const userRole = localStorage.getItem("user-role");

  const { openUpgradeModal } = useUpgradeModal();
  const { data: crmBgAccountCheck, refetch } = useCrmBgAccountCheckQuery(
    {},
    {
      skip: !(userRole && userRole.trim().toLowerCase() === "admin"),
    }
  );

  //notification bell

  const socket = useWebSocket();

  const newNotification =
    socket?.state?.serverResponse?.new_notification || null;
  const unreadNotifications = socket?.state?.serverResponse?.notification || [];

  useEffect(() => {
    if (permissionToShow) {
      const parsedPermission = JSON.parse(permissionToShow); // Parse the JSON string
      const teamPermissions = parsedPermission?.teams[0];
      // Find the key that you need dynamically
      const dynamicKey =
        Object.keys(teamPermissions).find((key) =>
          key.includes("module_permissions")
        ) || Object.keys(teamPermissions)[0];

      const permissionListValue = teamPermissions[dynamicKey] || []; // Ensure permissionListValue is an array
      setPermissionList(permissionListValue);
    }
  }, [permissionToShow]);

  const hasPermission = (permission) =>
    Array.isArray(permissionList) && permissionList.includes(permission);

  let initials = null;
  if (!!displayUserEmail) {
    initials = createInitials(displayUserEmail);
  }

  const closeUserMenu = () => {
    setIsUserMenuOpen(false);
    setIsUserMenuOpen2(false);
  };

  const handleSignOut = async () => {
    const isTelephonyLoggedIn =
      localStorage.getItem(TELEPHONY_LOGIN) === "true";
    const isCallActive = localStorage.getItem(CALL) === "true";

    if (isCallActive) {
      toast.error("Call is active");
      return;
    }

    if (isTelephonyLoggedIn) {
      toast.error(
        "Please log off telephony before signing out from application"
      );
      return;
    }

    setIsSigningOut(true);
    closeUserMenu();

    const payload = {
      username: displayUserEmail,
      password: displayPassword,
      tenant: displayTenantName,
      team: String(displayTeamId),
    };

    try {
      const response = await triggerLogout(payload);
      if (response.data?.success) {
        if (crmBgAccountCheck?.bg_id_enabled === true) {
          const userBgId = parseInt(currentUser?.id);
          if (!Number.isNaN(userBgId)) {
            await updateUserActiveStatus("offline", userBgId);
          }
        }
        localStorage.clear();
        window.location.reload();
      } else {
        setIsSigningOut(false);
        toast.error("Logout failed");
      }
    } catch (error) {
      setIsSigningOut(false);
      toast.error("An error occurred while logging out");
    }
  };

  const userId = localStorage.getItem("User_Id");

  const toolbarButtonMarginClass = "ms-lg-3";
  const toolbarUserAvatarHeightClass = `symbol-30px symbol-md-40px ${isUserMenuOpen ? "show menu-dropdown" : ""
    }`;


  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        headerUserDropdownMenuRef.current &&
        !headerUserDropdownMenuRef.current.contains(event.target as Node)
      ) {
        closeUserMenu();
      }
    };
    if (closeTopRightTool) {
      closeUserMenu();
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [closeTopRightTool]);

  const fetchingTenant = window.location.hostname.split(".")[0];
  const apiPort = process.env.REACT_APP_API_PROTOCOL;

  const gettingQueues = localStorage.getItem(QUEUE);

  useEffect(() => {
    if (gettingQueues) {
      const queuesArray = gettingQueues.split(",");
      setQueueus(queuesArray);
    }
  }, [gettingQueues]);
  //   useEffect(() => {
  //   let intervalId: NodeJS.Timeout;

  //   const allowedTenants = ["stage", "meta", "livquik", "globiter2"];

  //   const checkExtensionRegistration = async () => {
  //     try {
  //       const extensionNo = localStorage.getItem(EXTENSION);
  //       const tenant = fetchingTenant;

  //       if (!extensionNo || !allowedTenants.includes(tenant)) return;

  //       const response = await axios.get(
  //         `${apiPort}://${tenant}.${process.env.REACT_APP_BASE_URL}/v1/telephony/extension-registration-check/${extensionNo}`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
  //           },
  //         }
  //       );

  //       const isRegistered = response?.data?.data?.is_registered;

  //       if (!isRegistered) {
  //         toast.warning("Extension unregistered. Logging out...");
  //         await telephonyLogoutHandler({ preventDefault: () => {} });
  //       }
  //     } catch (error) {
  //       console.error("Extension check failed:", error);
  //     }
  //   };

  //   if (isLoggedIn && allowedTenants.includes(fetchingTenant)) {
  //     intervalId = setInterval(checkExtensionRegistration, 5000);
  //   }

  //   return () => {
  //     if (intervalId) clearInterval(intervalId);
  //   };
  // }, [isLoggedIn, fetchingTenant]);


  const callBreakId = localStorage.getItem(CALLBREAKID);
  const telephonyLoginId = localStorage.getItem(TELEPHONYLOGINID);

  const telephonyHandler = async (e) => {
    e.preventDefault();

    setIsLoading(true);
    setLoading(true);
    if (displayTenantName === "cloudtelephony" || displayTenantName === "cslfinance") {
      const czParams = new URLSearchParams();
      czParams.append("username", "CSL_API");
      czParams.append("password", "Cslapi$#@4321");

      try {
        const czLoginResponse = await axios.post(
          "https://czapi.c-zentrix.com/CZ_API/login",
          czParams,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );

        console.log("CZ Login Success:", czLoginResponse.data);
        console.log("CZ Login Success1:", czLoginResponse?.data?.response?.Message?.token);

        // Optionally store token if needed
        const czToken = czLoginResponse?.data?.response?.Message?.token;
        if (czToken) {
          localStorage.setItem("cz_token", czToken); // ✅ Store token here
          console.log("CZ token stored:", czToken);
        } else {
          console.warn("CZ token not found in response");
        }

        // Mark telephony login as active
        localStorage.setItem("telephony_login", "true");
        setIsLoggedIn(true);
        setIsLoading(false);
        setLoading(false);
        toast.success("Telephony logged in successfully.");
        return;
      } catch (error) {
        console.error("CZ Login Failed:", error);
        toast.error("CZ API login failed.");
        setIsLoggedIn(false);
        setIsLoading(false);
        setLoading(false);
        return;
      }
    }

    try {
      // Step 1: Fetch server configuration
      const serverConfigResponse = await axios.get(
        `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/telephony/telephony-server-config`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          },
        }
      );

      if (!serverConfigResponse?.data?.results?.length) {
        throw new Error("Server configuration not found.");
      }

      const serverConfig = serverConfigResponse.data.results[0];
      setServerConfig(serverConfig);
      localStorage.setItem(TELEPHONEURL, JSON.stringify(serverConfig));

      // Step 2: Fetch telephony extension
      const telephonyExtensionResponse = await axios.get(
        `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/users/user-telephony-extension/?user_id=${userId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          },
        }
      );

      const telephonyData = telephonyExtensionResponse?.data?.[0];
      if (!telephonyData) {
        throw new Error("Telephony extension data not found.");
      }

      const extensionNo = telephonyData?.extension_no;
      const username = telephonyData?.user?.username;

      if (!extensionNo) {
        throw new Error("Extension number is missing.");
      }

      const allowedTenants = ["stage", "meta", "livquik", "globiter2","payswiff"];
      if (allowedTenants.includes(fetchingTenant)) {
        const telephonyExtensionCheck = await axios.get(
          `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/telephony/extension-registration-check/${extensionNo}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
            },
          }
        );
        const extensionStatusData = telephonyExtensionCheck?.data?.data;
        if (!extensionStatusData?.is_registered) {
          throw new Error("Please make sure your extension is registered.");
        }
      }

      const queuePenaltyMapping = telephonyData?.queue_penalty_mapping || {};
      const queueNamesData = telephonyData?.queues?.map((queue) => ({
        ...queue,
        penalty: queuePenaltyMapping[queue.id] || 0, // Assign penalty based on queue ID
      }));

      const fetchingExtensionNo = telephonyData?.extension_no;
      const fetchingUserName = telephonyData?.user?.username;

      localStorage.setItem(EXTENSION, fetchingExtensionNo);
      setExtensionNo(fetchingExtensionNo);
      setUserName(fetchingUserName);
      setStoringUserName(fetchingUserName);

      const campaignString = queueNamesData
        .map((queue) => queue?.name)
        .join(",");
      localStorage.setItem(QUEUE, JSON.stringify(campaignString));

      // Unified function to process queue operations
      const processQueueOperation = async (operation) => {
        const batchPromises = queueNamesData.map(async (queue) => {
          const sanitizedQueue = queue?.name
            ?.replace(/['"]+/g, "")
            .trim()
            .replace(/\s+/g, "");

          const url = localStorage.getItem(TELEPHONEURL);
          const telephoneData = JSON.parse(url);
          const apiUrl =
            telephoneData?.https_port > 0
              ? `https://${telephoneData.domain}:${telephoneData.https_port}/click2call/acd.php?AgentExten=${fetchingExtensionNo}&Operation=${operation}&Queue=${sanitizedQueue}&SecKey=2c41c5e95e052e9d03f423e9f578b9b3&AgentName=${fetchingUserName}&Penalty=${queue.penalty}&PauseCode=Not Ready`
              : `https://${telephoneData.domain}/click2call/acd.php?AgentExten=${fetchingExtensionNo}&Operation=${operation}&Queue=${sanitizedQueue}&SecKey=2c41c5e95e052e9d03f423e9f578b9b3&AgentName=${fetchingUserName}&Penalty=${queue.penalty}&PauseCode=Not Ready`;

          await axios.post(
            apiUrl,
            {},
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
              },
            }
          );
        });

        await Promise.all(batchPromises);
      };

      await processQueueOperation("remove");
      await processQueueOperation("add");

      // Step 3: Telephony login
      const telephonyLoginResponse = await axios.post(
        `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/users/telephony-login/`,
        { campaigns: campaignString },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          },
        }
      );

      if (!telephonyLoginResponse?.data?.id) {
        throw new Error("Telephony login failed.");
      }

      setStoredTelephonyLoginDetails(telephonyLoginResponse?.data);
      localStorage.setItem("user_Id", telephonyLoginResponse?.data?.user_id);
      localStorage.setItem(TELEPHONYLOGINID, telephonyLoginResponse?.data?.id);
      localStorage.setItem(
        TELPEHONYLOGINUSERID,
        telephonyLoginResponse?.data?.user_id
      );

      await processQueueOperation("pause");

      // Step 4: Call breaks
      const callBreaksResponse = await axios.post(
        `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/users/call-breaks/`,
        { break_remark: "Not Ready", user_id: +userId },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          },
        }
      );

      setCallBreakId(callBreaksResponse?.data?.id);
      localStorage.setItem(
        CALL_BREAK_REMARK,
        callBreaksResponse?.data?.break_remark
      );
      localStorage.setItem(CALLBREAKID, callBreaksResponse?.data?.id);

      // Step 5: Update extension state
      await axios.post(
        `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/telephony/extension-states/`,
        { extension: fetchingExtensionNo, state: "pause" },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          },
        }
      );

      toast.success("Telephony logged in successfully!");
      localStorage.setItem(TELEPHONY_LOGIN, "true");
      setCloseTopRightTool(true);
      setIsLoading(false);
      setIsLoggedIn(true);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("An error occurred:", error);
      toast.error(
        error?.message || "An error occurred during telephony setup."
      );
      setIsLoggedIn(false);
      setIsLoading(false);
    }
  };
  console.log(crmBgAccountCheck?.bg_id_enabled, "check");

  const mobileNumber = localStorage.getItem("liftingMobileNumber");

  const callStatus = localStorage.getItem(CALL);

  const telephonyLogoutHandler = async (e: any) => {
    if (callStatus === "true") {
      toast.warning("You are on the call");
      return;
    }
    e.preventDefault();
    setLoading(true);
    setIsLoading(true);
    if (displayTenantName === "cloudtelephony" || displayTenantName === "cslfinance") {
      localStorage.setItem("telephony_login", "false");
      setIsLoggedIn(false);
      setIsLoading(false);
      setLoading(false);
      toast.success("Telephony logout successfully!");
      return;
    }
    try {
      const url = localStorage.getItem(TELEPHONEURL);
      const telephoneData = JSON.parse(url || "{}");
      const extension = localStorage.getItem(EXTENSION);

      // Step 1: Unpause Batch
      const unpauseBatch = async (batch: any[]) => {
        const batchPromise = batch.map(async (queue) => {
          const sanitizedQueue = queue
            .replace(/['"]+/g, "")
            .trim()
            .replace(/\s+/g, "");

          try {
            const url =
              telephoneData?.https_port > 0
                ? `https://${telephoneData?.domain}:${telephoneData?.https_port}/click2call/acd.php?AgentExten=${extension}&Operation=unpause&Queue=${sanitizedQueue}&SecKey=2c41c5e95e052e9d03f423e9f578b9b3&AgentName=${storingUserName}&Penalty=${queue?.penalty}`
                : `https://${telephoneData?.domain}/click2call/acd.php?AgentExten=${extension}&Operation=unpause&Queue=${sanitizedQueue}&SecKey=2c41c5e95e052e9d03f423e9f578b9b3&AgentName=${storingUserName}&Penalty=${queue?.penalty}`;

            await axios.post(
              url,
              {
                AgentExten: extension,
                Operation: "unpause",
                Queue: sanitizedQueue,
                SecKey: "2c41c5e95e052e9d03f423e9f578b9b3",
                AgentName: storingUserName,
                Penalty: queue?.penalty,
              },
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
                },
              }
            );
          } catch (error) {
            console.error(`Error unpausing queue: ${queue?.name}`, error);
          }
        });
        await Promise.all(batchPromise);
      };
      await unpauseBatch(queueus);

      // Step 2: Update Extension State
      await axios.post(
        `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/telephony/extension-states/`,
        { extension, state: "unpause" },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          },
        }
      );

      // Step 3: Fetch Inbound Call
      await axios.get(
        `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/telephony/inbound-call/?extension=${extension}&`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          },
        }
      );

      // Step 4: Resume Call Break
      await axios.post(
        `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/users/call-breaks/${callBreakId}/`,
        { action: "resume" },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          },
        }
      );

      // Step 5: Remove Batch
      const removeBatch = async (batch: any[]) => {
        const batchPromise = batch.map(async (queue) => {
          const sanitizedQueue = queue
            .replace(/['"]+/g, "")
            .trim()
            .replace(/\s+/g, "");

          const url =
            telephoneData?.https_port > 0
              ? `https://${telephoneData?.domain}:${telephoneData?.https_port}/click2call/acd.php?AgentExten=${extension}&Operation=remove&Queue=${sanitizedQueue}&SecKey=2c41c5e95e052e9d03f423e9f578b9b3&AgentName=${storingUserName}&Penalty=${queue?.penalty}`
              : `https://${telephoneData?.domain}/click2call/acd.php?AgentExten=${extension}&Operation=remove&Queue=${sanitizedQueue}&SecKey=2c41c5e95e052e9d03f423e9f578b9b3&AgentName=${storingUserName}&Penalty=${queue?.penalty}`;

          try {
            await axios.post(
              url,
              {
                AgentExten: extension,
                Operation: "remove",
                Queue: sanitizedQueue,
                SecKey: "2c41c5e95e052e9d03f423e9f578b9b3",
                AgentName: storingUserName,
                Penalty: queue?.penalty,
              },
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
                },
              }
            );
          } catch (error) {
            console.error(`Error removing queue: ${queue?.name}`, error);
          }
        });
        await Promise.all(batchPromise);
      };
      await removeBatch(queueus);

      // Step 6: Logout
      await axios.post(
        `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/users/telephony-login/${telephonyLoginId}/`,
        { action: "logout", logout_reason: "Self Logout" },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          },
        }
      );

      // Clean up localStorage
      localStorage.removeItem(TELEPHONEURL);
      localStorage.removeItem(CALLBREAKID);
      localStorage.removeItem(EXTENSION);
      localStorage.removeItem(QUEUE);
      localStorage.setItem(TELEPHONY_LOGIN, "false");

      setExtensionNo("");
      setQueueNames([]);
      setServerConfig("");
      setUserName("");
      setCallBreakId("");
      toast.success("Telephony logout successfully!");
      setIsLoading(false);
      setIsLoggedIn(false);
      setLoading(false);
      setCloseTopRightTool(true);
    } catch (error) {
      console.error("Error during telephony logout process:", error);
      setIsLoading(false);
      setLoading(false);
    } finally {
      setLoading(false);
      setIsLoading(false);
    }
  };
  const checkTeam = localStorage.getItem(CIRCLEONE_TEAM);
  const checkUsername = localStorage.getItem(CIRCLEONE_USERNAME);

  const restricteduser =
    checkTeam === "Botgo" && checkUsername === "vivek@gtbotgo.io";

  // State for New dropdown
  const [isNewMenuOpen, setIsNewMenuOpen] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [showAccountModal, setShowAccountModal] = useState(false);
  const [showTicketModal, setShowTicketModal] = useState(false);
  const [refetchingData, setRefetchingData] = useState(false);
  const newMenuRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  // Close all modals
  const closeAllModals = () => {
    setShowContactModal(false);
    setShowAccountModal(false);
    setShowTicketModal(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        newMenuRef.current &&
        !newMenuRef.current.contains(event.target as Node)
      ) {
        setIsNewMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleNewMenu = () => {
    setIsNewMenuOpen(!isNewMenuOpen);
  };

  const closeTicketModal = () => {
    setShowTicketModal(false);
  };

  const customModalStyles1 = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "100%", // Default to full width
      maxWidth: "850px", // Max width for larger screens
      height: "80%",
      margin: "auto",
      Overflow: "hidden",
      OverflowY: "auto",
    },
  };


  const planName = localStorage.getItem("planName") || "";
  const isFreeOrFreemium =
    planName === "Free" || planName === "Freemium";
    

  return (
    <>
      {/* Modals */}
      <Modal
        open={showContactModal}
        onClose={() => setShowContactModal(false)}
        aria-labelledby="add-contact-modal"
        aria-describedby="modal-to-add-new-contact"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80%",
            maxWidth: 800,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 1,
            maxHeight: "90vh",
            overflowY: "auto",
          }}
        >
          <IconButton
            aria-label="close"
            onClick={() => setShowContactModal(false)}
            sx={{
              position: "fixed",
              top: 16,
              right: 16,
              zIndex: 1301,
              background: "white",
            }}
          >
            <GridCloseIcon />
          </IconButton>
          <Typography
            id="modal-title"
            variant="h6"
            component="h2"
            sx={{ mb: 2 }}
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            Contact
          </Typography>
          <ContactModal
            closeModal={() => setShowContactModal(false)}
            refetchingData={refetchingData}
          />
        </Box>
      </Modal>

      <Modal
        open={showAccountModal}
        onClose={() => setShowAccountModal(false)}
        aria-labelledby="add-account-modal"
        aria-describedby="modal-to-add-new-account"
        BackdropProps={{
          style: {
            backgroundColor: "rgba(0, 0, 0, 0.2)",
          },
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80%",
            maxWidth: 800,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 1,
            maxHeight: "90vh",
            overflowY: "auto",
          }}
        >
          <IconButton
            aria-label="close"
            onClick={() => setShowAccountModal(false)}
            sx={{
              position: "fixed",
              top: 16,
              right: 16,
              zIndex: 1301,
              background: "white",
            }}
          >
            <GridCloseIcon />
          </IconButton>
          <Typography
            id="modal-title"
            variant="h6"
            component="h2"
            sx={{ mb: 2 }}
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            Account
          </Typography>
          <AccountModal
            closeModal={() => setShowAccountModal(false)}
            refetchingData={refetchingData}
          />
        </Box>
      </Modal>
      <ReactModal
        isOpen={showTicketModal}
        onRequestClose={closeTicketModal}
        style={customModalStyles1}
        shouldCloseOnOverlayClick={false}
        contentLabel="New Ticket"
      >
        <TicketModal
          closeModal={() => setShowTicketModal(false)}
          setIsLoading={setIsLoading}
          refetch={() => { }}
          refetchWorkflow={() => { }}
          selectedWorkflow={null}
        />
      </ReactModal>

      <div
        className={clsx("d-flex align-items-center", toolbarButtonMarginClass)}
        ref={headerUserDropdownMenuRef}
      >
        {/* New Dropdown with Icon */}
        <div className="dropdown me-4" ref={newMenuRef}>
          <button
            className="btn btn-icon btn-clean btn-active-light-primary btn-sm"
            onClick={toggleNewMenu}
            style={{
              width: "36px",
              height: "36px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "0.475rem",
              backgroundColor: "#f1faff",
              color: "#6366f1",
            }}
          >
            <i className="fas fa-plus fs-3"></i>
          </button>
          {isNewMenuOpen && (
            <div
              className="dropdown-menu show"
              style={{
                position: "absolute",
                left: "0",
                right: "auto",
                minWidth: "200px",
                marginTop: "0.5rem",
                boxShadow: "0 0 50px 0 rgb(82 63 105 / 15%)",
                border: "0",
                borderRadius: "0.475rem",
                padding: "0.5rem 0",
                zIndex: 1080,
              }}
            >
              {/* Add Account */}
              <div className="menu-item px-3">
                {isFreeOrFreemium ? (
                  <div
                    className="dropdown-item text-gray-500"
                    style={{ cursor: "not-allowed", color: "#adb5bd" }}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      openUpgradeModal();
                    }}
                  >
                    <i className="fas fa-building me-2" style={{ color: "#adb5bd" }}></i> Add account
                  </div>
                ) : (
                  <div
                    className="dropdown-item text-gray-800"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setIsNewMenuOpen(false);
                      setShowAccountModal(true);
                    }}
                  >
                    <i className="fas fa-building me-2"></i> Add account
                  </div>
                )}
              </div>

              {/* Add Contact */}
              <div className="menu-item px-3">
                {isFreeOrFreemium ? (
                  <div
                    className="dropdown-item text-gray-500"
                    style={{ cursor: "not-allowed", color: "#adb5bd" }}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      openUpgradeModal();
                    }}
                  >
                    <i className="fas fa-user me-2" style={{ color: "#adb5bd" }}></i> Add contact
                  </div>
                ) : (
                  <div
                    className="dropdown-item text-gray-800"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setIsNewMenuOpen(false);
                      setShowContactModal(true);
                    }}
                  >
                    <i className="fas fa-user me-2"></i> Add contact
                  </div>
                )}
              </div>

              {/* Create Ticket */}
              <div className="menu-item px-3">
                {isFreeOrFreemium ? (
                  <div
                    className="dropdown-item text-gray-500"
                    style={{ cursor: "not-allowed", color: "#adb5bd" }}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      openUpgradeModal();
                    }}
                  >
                    <i className="fas fa-ticket-alt me-2" style={{ color: "#adb5bd" }}></i> Create ticket
                  </div>
                ) : (
                  <div
                    className="dropdown-item text-gray-800"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setIsNewMenuOpen(false);
                      setShowTicketModal(true);
                    }}
                  >
                    <i className="fas fa-ticket-alt me-2"></i> Create ticket
                  </div>
                )}
              </div>

              {/* New Email */}
              <div className="menu-item px-3">
                {isFreeOrFreemium ? (
                  <div
                    className="dropdown-item text-gray-500"
                    style={{ cursor: "not-allowed", color: "#adb5bd" }}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      openUpgradeModal();
                    }}
                  >
                    <i className="far fa-envelope me-2" style={{ color: "#adb5bd" }}></i> New email
                  </div>
                ) : (
                  <Link
                    to="/email/compose"
                    className="dropdown-item text-gray-800"
                    onClick={() => {
                      setIsNewMenuOpen(false);
                    }}
                  >
                    <i className="far fa-envelope me-2"></i> New email
                  </Link>
                )}
              </div>
            </div>
          )}
        </div>
        <div
          style={{
            padding: "2px",
          }}
        >
          <span>
            <LiveClock />
          </span>
        </div>

        <div className="d-flex justify-content-end p-4">
          <NotificationBell
            newNotification={newNotification}
            unreadNotifications={unreadNotifications}
          />
        </div>
        <div
          className={clsx(
            "cursor-pointer symbol d-flex align-items-center",
            toolbarUserAvatarHeightClass
          )}
        >
          <span
            className={`symbol-label bg-primary text-light-dark fs-4 fw-bolder`}
            onClick={() => setIsUserMenuOpen2(!isUserMenuOpen2)}
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer"
            }}
          >
            {initials?.label}
          </span>
        </div>
        <Dropdown
          menuRef={headerUserDropdownMenuRef}
          droppedDown={isUserMenuOpen2}
          setDroppedDown={setIsUserMenuOpen}
        >
          <div className="card-body">
            <div className="menu-content d-flex align-items-center px-3">
              <div className="symbol symbol-50px me-5">
                <span
                  className={`symbol-label bg-primary text-light-dark fs-4 fw-bolder`}
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {initials?.label}
                </span>
              </div>

              <div className="d-flex flex-column">
                <div className="fw-bolder d-flex align-items-center fs-5">
                  {displayTenantName || "Unknown User"}
                </div>
                <span className="fw-bold text-muted text-hover-primary fs-7">
                  {displayUserEmail ? maskEmail(displayUserEmail) : ""}
                </span>
              </div>
            </div>
          </div>

          <div className="separator my-2"></div>
          <div className="menu-item px-5">
            <Link
              to="/user-profile"
              onClick={closeUserMenu}
              className="menu-link px-5"
            >
              My Profile
            </Link>
          </div>
          {/* {!restricteduser &&  */}
          <div className="separator my-2"></div>
          {/* } */}

          <div className="menu-item px-5">
            <a
              href="https://botgo.io/support/"
              target="_blank"
              rel="noopener noreferrer"
              onClick={closeUserMenu}
              className="menu-link px-5"
            >
              Help
            </a>
          </div>

          <div className="separator my-2"></div>
          {!isFreeOrFreemium && (
            <>
              { userRole === "admin" && (
                <>

              {!restricteduser && (
                <>
                  {displayTenantName === "victorinox" ? (
                    <span
                      style={{
                        color: "grey",
                        padding: "4px 33px",
                        cursor: "default",
                      }}
                    >
                      Call History
                    </span>
                  ) : (
                    <div className="menu-item px-5">
                      <Link
                        to="/call-history"
                        onClick={closeUserMenu}
                        className="menu-link px-5"
                      >
                        Call History
                      </Link>
                    </div>
                  )}
                    <div className="separator my-2"></div>
                </>
              )}
              </>
              )}
              {!restricteduser && (
                <>
                

                  {hasPermission("phone:enable") && (
                    <>
                      <div
                        className="menu-item px-5"
                        style={{
                          paddingLeft: "0px",
                          display: "flex",
                          justifyContent: "flex-start",
                        }}
                      >
                        {displayTenantName === "victorinox" ? (
                          <span style={{ padding: "5px 15px", color: "grey" }}>
                            Telephony Login
                          </span>
                        ) : (
                          <div
                            style={{
                              paddingLeft: "0px",
                              display: "flex",
                              justifyContent: "flex-start",
                              width: "100%",
                            }}
                          >
                            {!isLoggedIn ? (
                              <span
                                className="menu-link px-5"
                                style={{
                                  border: "none",
                                  background: "transparent",
                                  // color: "#7e8299",
                                  // padding: "5px",
                                  width: "100%",
                                  paddingLeft: "0px",
                                  // color: "grey",
                                  // cursor: "default"
                                }}
                                onClick={telephonyHandler}
                              >
                                {loading ? <LoadingSkeleton /> : "Telephony Login"}
                              </span>
                            ) : (
                              <span
                                className="menu-link px-5"
                                onClick={telephonyLogoutHandler}
                                style={{
                                  border: "none",
                                  background: "transparent",
                                  // color: "grey",
                                  // color: "#7e8299",
                                  paddingLeft: "0px",

                                  width: "100%",
                                }}
                              >
                                {loading ? <LoadingSkeleton /> : "Telephony Logout"}
                              </span>
                            )}
                          </div>
                        )}
                      </div>

                      <div className="separator my-2"></div>
                    </>
                  )}
                </>
              )}
              <div className="menu-item px-5">
                <div
                  className={`menu-link px-5 ${
                    mobileNumber || isSigningOut ? "disabled-link" : ""
                  }`}
                  onClick={handleSignOut}
                >
                  {isSigningOut ? "Signing out..." : "Sign Out"}
                </div>
              </div>
             
            </>
          )}

          {isFreeOrFreemium && (
            <>
            {userRole === "Admin" && (
              <>
            
              <span
                style={{
                  color: "#adb5bd",
                  padding: "4px 33px",
                  cursor: "default",
                }}

                onClick={() => openUpgradeModal()}
              >
                Call History
              </span>
              <div className="separator my-2"></div>
              </>
            )
            }


              <div
                className="menu-item px-5"
                style={{
                  paddingLeft: "0px",
                  display: "flex",
                  justifyContent: "flex-start",
                }}
              >
                <span style={{ padding: "5px 15px", color: "#adb5bd" }} onClick={() => openUpgradeModal()} >
                  Telephony Login
                </span>
              </div>
              <div className="separator my-2"></div>

              <div className="menu-item px-5">
                <div
                  className={`menu-link px-5 ${
                    mobileNumber || isSigningOut ? "disabled-link" : ""
                  }`}
                  onClick={handleSignOut}
                >
                  {isSigningOut ? "Signing out..." : "Sign Out"}
                </div>
              </div>
              <div className="separator my-2"></div>
            
            </>
          )}
        </Dropdown>
      </div>

      {/* begin::Aside Toggler */}
      {config.header.left === "menu" && (
        <div
          className="d-flex align-items-center d-lg-none ms-2 me-n3"
          title="Show header menu"
        >
          <div
            className="btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px"
            id="kt_header_menu_mobile_toggle"
          >
            <KTSVG
              path="/media/icons/duotune/text/txt001.svg"
              className="svg-icon-1"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default TopRightTools;
